var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"transparent",attrs:{"flat":"","tile":"","width":"100%","height":"100%"}},[_vm._v(" ActiveSession "+_vm._s(_vm.ActiveSession)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }